import { render, staticRenderFns } from "./HomeStudent.vue?vue&type=template&id=4fb7a878&scoped=true&"
import script from "./HomeStudent.vue?vue&type=script&lang=js&"
export * from "./HomeStudent.vue?vue&type=script&lang=js&"
import style0 from "./HomeStudent.vue?vue&type=style&index=0&id=4fb7a878&media=screen&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb7a878",
  null
  
)

export default component.exports